<div id="income-content" class="divWhiteBackground">
  <form
    id="cac-primary-income-details-form"
    class="formStyle"
    [formGroup]="incomeForm"
  >
    <div id="cac-income-div-estimateTime" class="form-group">
      <h2 class="dark-blue bold center" id="cac-income-tellus-h2">
        {{ globalText?.income?.title }}
      </h2>
      <div class="dark-blue-80 center" id="cac-income-estd-span">
        {{ globalText?.income?.subTitle }}
      </div>
    </div>
    <div class="form-group pt-40">
      <div
        role="alert"
        *ngIf="profinityFlag"
        aria-atomic="true"
        id="profanityErrorDiv"
        class="validation-error"
      >
        Profanity found in the text entered.
      </div>
    </div>
    <div id="gross-income-error">
      <div
        role="alert"
        aria-atomic="true"
        *ngIf="(belowMinimum && combinedIncome) || excessIncomeFlag"
        class="desktop btn-actions desktop-97-5 divblock ErrmonthlyPay errWidthL required validation-error mobileView-pb-15 side-padding-20"
      >
        {{
          belowMinimum
            ? globalText?.income?.errors?.gie1
            : 'Combined bi-weekly income cannot be more than $461,538'
        }}
      </div>
    </div>
    <div class="divwid"></div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-income-div-error-incomeType"
          [ngClass]="
            f.incomeType.touched && f.incomeType.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group dropdown-caret"
        >
          <p
            id="cac-income-label-incomeType"
            htmlFor="incomeType"
            class="dark-blue control-label form-field-black"
            [class.validation-error]="
              f.incomeType.touched && f.incomeType.errors
            "
          >
            {{ formFieldData?.incomeType?.label }}
          </p>

          <select
            id="incomeType"
            class="form-control col-left form-field-black"
            aria-labelledby="cac-income-label-incomeType"
            name="incomeType"
            formControlName="incomeType"
            (blur)="parseInputAndValidate($event, 'incomeType', 'primary')"
          >
            <option
              *ngFor="let item of this.incomeOptionsList"
              [value]="item.value"
            >
              {{ item.label }}
            </option>
          </select>
          <span
            *ngIf="
              f.incomeType.touched &&
              f.incomeType.errors &&
              f.incomeType.errors.isMatchingOneOf
            "
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="
            f.incomeType.touched &&
            f.incomeType.errors &&
            f.incomeType.errors.isMatchingOneOf
          "
          role="alert"
          aria-atomic="true"
          class="ErrincomeType errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.incomeType?.errors?.ite1 }}
        </div>
        <div class="custom-display-inline col-md-8 desktop">
          <div
            role="alert"
            aria-atomic="true"
            *ngIf="
              f.incomeType.touched &&
              f.incomeType.errors &&
              f.incomeType.errors.isMatchingOneOf
            "
            class="ErrincomeType required validation-error mobileView-pb-15 error-message"
          >
            {{ formFieldData?.incomeType?.errors?.ite1 }}
          </div>
        </div>
      </div>
      <div
        class="custom-column-full custom-display-inline col-md-8 vertical-align-top"
      >
        <div
          id="cac-income-div-error-biWeeklyPay"
          class="form-group"
          [ngClass]="
            f.biWeeklyPay.touched && f.biWeeklyPay.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-income-label-biWeeklyPay"
            htmlFor="biWeeklyPay"
            class="dark-blue form-field-black control-label"
            [class.validation-error]="
              f.biWeeklyPay.touched && f.biWeeklyPay.errors
            "
          >
            {{ formFieldData?.biWeeklyPay?.label }}&nbsp;
            <span
              tabindex="0"
              ngbTooltip="{{ formFieldData?.biWeeklyPay?.tooltip?.content }}"
              triggers="click hover keypress"
              placement="bottom"
              [tooltipClass]="'ngb-custom-tooltip'"
              aria-describedby="cac-income-label-biWeeklyPay"
            >
              <img
                alt="{{ formFieldData?.biWeeklyPay?.tooltip?.altContent }}"
                src="{{ icnIconURL }}"
              />
            </span>
          </p>

          <div class="amount">
            <input
              id="cac-income-biWeeklyPay"
              aria-labelledby="cac-income-label-biWeeklyPay"
              type="text"
              inputmode="numeric"
              class="form-control col-right inputtext blue-60 form-field-black"
              name="biWeeklyPay"
              formControlName="biWeeklyPay"
              maxLength="6"
              min="1"
              (change)="transformAmount($event)"
              appTwoDigitDecimalNumber
              (blur)="parseInputAndValidate($event, 'biWeeklyPay', 'primary')"
            />
          </div>
          <span
            *ngIf="f.biWeeklyPay.touched && f.biWeeklyPay.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            f.biWeeklyPay.touched &&
            (f.biWeeklyPay.errors?.isNotEmpty || f.biWeeklyPay.errors?.isOfType)
          "
          class="ErrmonthlyPay mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.biWeeklyPay?.errors?.bwe1 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          class="divincome font-14 control-label"
          *ngIf="+f.biWeeklyPay.value.replaceAll(',', '') <= 450000"
        >
          ${{ biweeklyIncome }} Bi-Weekly = ${{ monthlyincome }}/Monthly = ${{
            annualIncome
          }}/Annually
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="f.biWeeklyPay.errors?.isLessOrEq"
          class="ErrmonthlyPay required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.biWeeklyPay?.errors?.bwe2 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8"></div>
      <div class="custom-display-inline col-md-8">
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            (f.biWeeklyPay.touched &&
              f.biWeeklyPay.errors &&
              f.biWeeklyPay.errors.isNotEmpty) ||
            (f.biWeeklyPay.touched &&
              f.biWeeklyPay.errors &&
              f.biWeeklyPay.errors.isOfType)
          "
          class="ErrmonthlyPay required validation-error mobileView-pb-15 error-message"
        >
          {{ f.biWeeklyPay.value }}
          {{ formFieldData?.biWeeklyPay?.errors?.bwe1 }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-income-div-error-hireDate"
          class="form-group"
          [ngClass]="
            (f.hireDate.touched && f.hireDate.errors) ||
            dobMisMatchError ||
            futureDateError
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-income-label-hireDate"
            htmlFor="hireDate"
            class="dark-blue form-field-black control-label"
            [class.validation-error]="
              (f.hireDate.touched && f.hireDate.errors) ||
              dobMisMatchError ||
              futureDateError
            "
          >
            {{ formFieldData?.hireDate?.label }}
          </p>

          <input
            id="hireDate"
            aria-labelledby="cac-income-div-error-hireDate"
            type="text"
            inputmode="numeric"
            placeholder="MM/DD/YYYY"
            class="form-control col-left form-field-black"
            name="hireDate"
            formControlName="hireDate"
            maxLength="10"
            mask="00/00/0000"
            [dropSpecialCharacters]="false"
            (blur)="
              [
                parseInputAndValidate($event, 'hireDate', 'primary'),
                parseAndValidateDate($event)
              ]
            "
          />
          <span
            *ngIf="
              dobMisMatchError ||
              futureDateError ||
              (f.hireDate.touched && f.hireDate.errors)
            "
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            f.hireDate.touched &&
            f.hireDate.errors &&
            f.hireDate.errors.isNotEmpty
          "
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.hireDate?.errors?.hde1 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            f.hireDate.touched &&
            f.hireDate.errors &&
            f.hireDate.errors?.dateFormatValidator
          "
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.hireDate?.errors?.hde2 }}
        </div>
        <div
          *ngIf="dobMisMatchError"
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.hireDate?.errors?.hde3 }}
        </div>
        <div
          *ngIf="f.hireDate.errors?.isOfAgeOrOlder"
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.hireDate?.errors?.hde4 }}
        </div>
        <div
          *ngIf="futureDateError"
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.hireDate?.errors?.hde5 }}
        </div>
      </div>
      <div class="form-group desktop">
        <div class="custom-display-inline col-md-8">
          <div
            role="alert"
            aria-atomic="true"
            *ngIf="f.hireDate.touched && f.hireDate.errors?.isNotEmpty"
            class="ErrhireDate required validation-error mobileView-pb-15 error-message"
          >
            {{ formFieldData?.hireDate?.errors?.hde1 }}
          </div>
          <div
            role="alert"
            aria-atomic="true"
            *ngIf="
              f.hireDate.touched &&
              !f.hireDate.errors?.isNotEmpty &&
              f.hireDate.errors?.isDate
            "
            class="ErrhireDate required validation-error"
          >
            {{ formFieldData?.hireDate?.errors?.hde2 }}
          </div>
          <div
            role="alert"
            aria-atomic="true"
            *ngIf="
              f.hireDate.touched &&
              !f.hireDate.errors?.isNotEmpty &&
              (f.hireDate.errors?.isDate || f.hireDate.errors?.isOfAgeOrYounger)
            "
            aria-atomic="true"
            class="ErrhireDate required validation-error"
          >
            {{ formFieldData?.hireDate?.errors?.hde3 }}
          </div>
          <div
            *ngIf="dobMisMatchError"
            role="alert"
            aria-atomic="true"
            class="ErrmonthResiding required validation-error"
          >
            {{ formFieldData?.hireDate?.errors?.hde3 }}
          </div>
          <div
            *ngIf="f.hireDate.errors?.isOfAgeOrOlder"
            role="alert"
            aria-atomic="true"
            class="ErrmonthResiding required validation-error"
          >
            {{ formFieldData?.hireDate?.errors?.hde4 }}
          </div>
          <div
            *ngIf="futureDateError"
            role="alert"
            aria-atomic="true"
            class="ErrmonthResiding required validation-error"
          >
            {{ formFieldData?.hireDate?.errors?.hde5 }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" id="primary-source" *ngIf="f.employerName">
      <div class="div-display-block">
        <div class="form-group">
          <div class="custom-column-full custom-display-inline col-md-8">
            <div
              id="cac-income-div-error-employerName"
              [ngClass]="
                f.employerName &&
                f.employerName.touched &&
                f.employerName.errors
                  ? 'has-error'
                  : 'mobileView-pb-15'
              "
              class="form-group"
            >
              <p
                id="cac-income-label-employerName"
                htmlFor="employerName"
                class="dark-blue form-field-black"
                [class.validation-error]="
                  f.employerName &&
                  f.employerName.touched &&
                  f.employerName.errors
                "
              >
                {{ formFieldData?.employerName?.label }}
              </p>

              <input
                id="cac-income-employerName"
                type="text"
                class="form-control col-left form-field-black"
                aria-labelledby="cac-income-label-employerName"
                name="employerName"
                alphaNumerics
                formControlName="employerName"
                maxLength="30"
                (keydown)="checkAlphaNumPattern($event)"
                (blur)="
                  [
                    removeTrailingSpaces($event, true),
                    parseInputAndValidate($event, 'employerName', 'primary')
                  ]
                "
              />
              <span
                *ngIf="
                  f.employerName &&
                  f.employerName.touched &&
                  f.employerName.errors?.isNotEmpty
                "
                class="validation-error-icon"
                ><img class="error-icn" src="{{ exclamation }}" alt="err"
              /></span>
            </div>
            <div
              role="alert"
              *ngIf="
                f.employerName &&
                f.employerName.touched &&
                f.employerName.errors?.isNotEmpty
              "
              role="alert"
              aria-atomic="true"
              class="ErremployerName mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerName?.errors?.ene2 }}
            </div>
          </div>
          <div class="custom-column-full custom-display-inline col-md-8">
            <div
              id="cac-income-div-error-employerPhone"
              [ngClass]="
                f.employerPhone &&
                f.employerPhone.touched &&
                f.employerPhone.errors
                  ? 'has-error'
                  : 'mobileView-pb-15'
              "
              class="form-group"
            >
              <p
                id="cac-income-label-employerPhone"
                htmlFor="employerPhone"
                class="dark-blue form-field-black"
                [class.validation-error]="
                  f.employerPhone &&
                  f.employerPhone.touched &&
                  f.employerPhone.errors
                "
              >
                {{ formFieldData?.employerPhone?.label }}
              </p>
              <input
                id="cac-income-employerPhone"
                class="form-control col-right form-field-black"
                mask="000-000-0000"
                aria-labelledby="cac-income-label-employerPhone"
                name="employerPhone"
                formControlName="employerPhone"
                type="text"
                inputmode="numeric"
                (blur)="
                  parseInputAndValidate($event, 'employerPhone', 'primary')
                "
              />
              <span
                *ngIf="
                  f.employerPhone &&
                  f.employerPhone.touched &&
                  f.employerPhone.errors
                "
                class="validation-error-icon"
                ><img class="error-icn" src="{{ exclamation }}" alt="err"
              /></span>
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                f.employerPhone &&
                f.employerPhone.touched &&
                !f.employerPhone.errors?.isNotEmpty &&
                (f.employerPhone?.errors?.isOfType ||
                  f.employerPhone?.errors?.isOfLength)
              "
              class="ErremployerPhone mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerPhone?.errors?.phe1 }}
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                f.employerPhone &&
                f.employerPhone.touched &&
                f.employerPhone.errors &&
                f.employerPhone.errors.isNotEmpty
              "
              class="ErremployerPhone mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerPhone?.errors?.phe2 }}
            </div>
          </div>
        </div>
        <div class="form-group desktop flex-container desktop-only">
          <div class="custom-display-inline col-md-8">
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                f.employerName &&
                f.employerName.touched &&
                f.employerName.errors?.isNotEmpty
              "
              class="ErremployerName errWidthL required validation-error"
            >
              {{ formFieldData?.employerName?.errors?.ene2 }}
            </div>
          </div>
          <div class="custom-display-inline col-md-8">
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                f.employerPhone &&
                f.employerPhone.touched &&
                !f.employerPhone.errors?.isNotEmpty &&
                (f.employerPhone?.errors?.isOfType ||
                  f.employerPhone?.errors?.isOfLength)
              "
              class="ErremployerPhone errWidthL required validation-error"
            >
              {{ formFieldData?.employerPhone?.errors?.phe1 }}
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                f.employerPhone &&
                f.employerPhone.touched &&
                f.employerPhone.errors?.isNotEmpty
              "
              class="ErremployerPhone errWidthL required validation-error"
            >
              {{ formFieldData?.employerPhone?.errors?.phe2 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      id="pinvisible"
      class="position-absolute invisible"
      disabled
    ></button>
  </form>

  <div class="alimony">
    You don't need to include alimony, child support, or separate maintenance
    income if you don't wish to have it considered as a basis for repaying this
    obligation.
  </div>

  <div
    id="cac-income-div-secondsource"
    name="cac-income-div-secondsource"
    class="form-group displayInlineBlock"
  >
    <button
      type="button"
      class="buttonLink btn no-upper sixteen-px mb-15 divcheck Acceptance-Bold"
      [class.regularCursor]="showSecondaryIncomeForm"
      [class.disabled]="incomeForm.invalid"
      [disabled]="!showSecondaryIncomeForm && formIncomplete.primary"
      name="cac-income-secondsource-link"
      id="cac-income-secondsource-link"
      (click)="showSecondaryForm(true)"
    >
      {{ showSecondaryIncomeForm ? '- ' : '+ '
      }}{{ globalText?.income?.buttons?.addSecondary }}
    </button>
  </div>
  <span
    id="secondary-income"
    [ngClass]="
      showSecondaryIncomeForm ? 'div-display-block' : 'div-display-none'
    "
  >
    <button
      type="button"
      *ngIf="showSecondaryIncomeForm"
      id="cac-income-secondsource-remove"
      name="cac-income-secondsource-remove"
      class="float-right btn mb-15 requiredTxt Acceptance-Bold"
      (click)="showSecondaryForm(false)"
    >
      {{ globalText?.income?.buttons?.removSecondary }}
    </button>
  </span>
  <form
    id="cac-secondary-income-details-form"
    class="formStyle"
    [formGroup]="secIncomeForm"
    *ngIf="showSecondaryIncomeForm"
  >
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-income-div-error-sf-incomeType"
          [ngClass]="
            sf.incomeType.touched && sf.incomeType.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group dropdown-caret"
        >
          <p
            id="cac-income-label-incomeType"
            htmlFor="incomeType"
            class="dark-blue control-label form-field-black"
            [class.validation-error]="
              sf.incomeType.touched && sf.incomeType.errors
            "
          >
            Income type
          </p>

          <select
            id="sf-incomeType"
            class="form-control col-left form-field-black"
            aria-labelledby="cac-income-label-incomeType"
            name="incomeType"
            formControlName="incomeType"
            (blur)="parseInputAndValidate($event, 'incomeType', 'secondary')"
          >
            <option *ngFor="let item of incomeOptionsList" [value]="item.value">
              {{ item.label }}
            </option>
          </select>
          <span
            *ngIf="sf.incomeType.touched && sf.incomeType.errors?.isNotEmpty"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="sf.incomeType.touched && sf.incomeType.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="ErrincomeType errWidthL mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.incomeType?.errors?.ite1 }}
        </div>
        <div class="form-group desktop">
          <div class="custom-display-inline col-md-8">
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                (sf.incomeType.touched && sf.incomeType.errors?.isNotEmpty) ||
                (sf.incomeType.touched && sf.incomeType.errors?.isDate)
              "
              class="ErrincomeType errWidthL required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.incomeType?.errors?.ite1 }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="custom-column-full custom-display-inline col-md-8 vertical-align-top"
      >
        <div
          id="cac-income-div-error-sf-biWeeklyPay"
          class="form-group"
          [ngClass]="
            sf.biWeeklyPay.touched && sf.biWeeklyPay.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-income-label-biWeeklyPay-secondary"
            htmlFor="biWeeklyPay"
            class="dark-blue form-field-black"
            [class.validation-error]="
              sf.biWeeklyPay.touched && sf.biWeeklyPay.errors
            "
          >
            {{ formFieldData?.biWeeklyPay?.label }}&nbsp;
            <span
              tabindex="0"
              ngbTooltip="{{ formFieldData?.biWeeklyPay?.tooltip?.content }}"
              triggers="click hover keypress"
              placement="bottom"
              [tooltipClass]="'ngb-custom-tooltip'"
              aria-describedby="cac-income-label-biWeeklyPay-secondary"
            >
              <img
                alt="{{ formFieldData?.biWeeklyPay?.tooltip?.altContent }}"
                src="{{ icnIconURL }}"
              />
              <span class="taglib-text hide-accessible" tabindex="0">{{
                formFieldData?.biWeeklyPay?.tooltip?.content
              }}</span>
            </span>
          </p>

          <div class="amount">
            <input
              id="cac-sf-income-biWeeklyPay"
              aria-labelledby="cac-income-label-biWeeklyPay"
              inputmode="numeric"
              type="text"
              class="divcolor form-control col-right form-field-black"
              name="biWeeklyPay"
              formControlName="biWeeklyPay"
              maxLength="6"
              min="1"
              (change)="transformAmount($event, 'secondary')"
              appTwoDigitDecimalNumber
              (blur)="parseInputAndValidate($event, 'biWeeklyPay', 'secondary')"
            />
          </div>
          <span
            *ngIf="sf.biWeeklyPay.touched && sf.biWeeklyPay.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="sf.biWeeklyPay.touched && sf.biWeeklyPay.errors"
          class="ErrmonthlyPay errWidthL mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.biWeeklyPay?.errors?.bwe1 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="+sf.biWeeklyPay.value.replaceAll(',', '') <= 450000"
          class="divincome font-14 control-label"
        >
          ${{ secbiweeklyIncome }} Bi-Weekly = ${{ secmonthlyincome }}/Monthly =
          ${{ secannualIncome }}/Annually
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="sf.biWeeklyPay.errors?.isLessOrEq"
          class="ErrmonthlyPay required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.biWeeklyPay?.errors?.bwe2 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8"></div>
      <div class="custom-display-inline col-md-8">
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            sf.biWeeklyPay.touched &&
            (sf.biWeeklyPay.errors?.isNotEmpty ||
              sf.biWeeklyPay.errors?.isGreaterThan)
          "
          class="ErrmonthlyPay required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.biWeeklyPay?.errors?.bwe1 }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-income-div-error-sf-hireDate"
          class="form-group"
          [ngClass]="
            (sf.hireDate.touched && sf.hireDate.errors) ||
            secDobMisMatchError ||
            secFutureDateError
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-sec-income-label-hireDate"
            htmlFor="hireDate"
            class="dark-blue form-field-black"
            [class.validation-error]="
              (sf.hireDate.touched && sf.hireDate.errors) ||
              secDobMisMatchError ||
              secFutureDateError
            "
          >
            Start date
          </p>

          <input
            id="cac-sf-hireDate"
            aria-labelledby="cac-income-div-error-hireDate"
            type="text"
            inputmode="numeric"
            placeholder="MM/DD/YYYY"
            class="form-control col-left form-field-black"
            name="hireDate"
            formControlName="hireDate"
            maxLength="10"
            mask="00/00/0000"
            [dropSpecialCharacters]="false"
            (blur)="
              [
                parseInputAndValidate($event, 'hireDate', 'secondary'),
                parseAndValidateDate($event, 'secondary')
              ]
            "
          />
          <span
            *ngIf="
              secDobMisMatchError ||
              secFutureDateError ||
              (sf.hireDate.touched &&
                (sf.hireDate.errors?.isNotEmpty || sf.hireDate.errors?.isDate))
            "
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="sf.hireDate.touched && sf.hireDate.errors?.isNotEmpty"
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.hireDate?.errors?.hde1 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            sf.hireDate.touched &&
            !sf.hireDate.errors?.isNotEmpty &&
            sf.hireDate.errors?.isDate
          "
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.hireDate?.errors?.hde2 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            sf.hireDate.touched &&
            !sf.hireDate.errors?.isNotEmpty &&
            (sf.hireDate.errors?.isDate || sf.hireDate.errors?.isOfAgeOrYounger)
          "
          aria-atomic="true"
          class="ErrhireDate required validation-error"
        >
          {{ formFieldData?.hireDate?.errors?.hde3 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="secDobMisMatchError"
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.hireDate?.errors?.hde3 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="secFutureDateError"
          aria-atomic="true"
          class="ErrhireDate mobileOnly required validation-error mobileView-pb-15 error-message"
        >
          {{ formFieldData?.hireDate?.errors?.hde4 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-16">
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="sf.hireDate.touched && sf.hireDate.errors?.isNotEmpty"
          class="ErrhireDate required validation-error"
        >
          {{ formFieldData?.hireDate?.errors?.hde1 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            sf.hireDate.touched &&
            !sf.hireDate.errors?.isNotEmpty &&
            sf.hireDate.errors?.isDate
          "
          class="ErrhireDate required validation-error"
        >
          {{ formFieldData?.hireDate?.errors?.hde2 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="secDobMisMatchError"
          class="ErrhireDate required validation-error"
        >
          {{ formFieldData?.hireDate?.errors?.hde3 }}
        </div>
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="secFutureDateError"
          class="ErrhireDate required validation-error"
        >
          {{ formFieldData?.hireDate?.errors?.hde4 }}
        </div>
      </div>
    </div>
    <span id="primary-s_source" *ngIf="sf.employerName">
      <div class="div-display-block">
        <div class="form-group">
          <div class="custom-column-full custom-display-inline col-md-8">
            <div
              id="cac-income-div-error-sf-employerName"
              [ngClass]="
                sf.employerName &&
                sf.employerName.touched &&
                sf.employerName.errors
                  ? 'has-error'
                  : 'mobileView-pb-15'
              "
              class="form-group"
            >
              <p
                id="cac-sf-income-label-employerName"
                htmlFor="employerName"
                class="dark-blue form-field-black"
                [class.validation-error]="
                  sf.employerName &&
                  sf.employerName.touched &&
                  sf.employerName.errors
                "
              >
                {{ formFieldData?.employerName?.label }}
              </p>

              <input
                id="cac-secondary-income-employerName"
                type="text"
                class="form-control col-left form-field-black"
                aria-labelledby="cac-income-label-employerName"
                name="employerName"
                formControlName="employerName"
                maxLength="30"
                alphaNumerics
                (keypress)="checkAlphaNumPattern($event)"
                (blur)="
                  [
                    removeTrailingSpaces($event, false),
                    parseInputAndValidate($event, 'employerName', 'secondary')
                  ]
                "
              />
              <span
                *ngIf="
                  sf.employerName &&
                  sf.employerName.touched &&
                  (sf.employerName.errors?.isShorterOrEq ||
                    sf.employerName.errors?.isNotEmpty)
                "
                class="validation-error-icon"
                ><img class="error-icn" src="{{ exclamation }}" alt="err"
              /></span>
            </div>
            <div
              role="alert"
              *ngIf="
                sf.employerName &&
                sf.employerName.touched &&
                sf.employerName.errors &&
                sf.employerName.errors.isNotEmpty
              "
              role="alert"
              aria-atomic="true"
              class="ErremployerName mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerName?.errors?.ene2 }}
            </div>
          </div>
          <div class="custom-column-full custom-display-inline col-md-8">
            <div
              id="cac-income-div-error-s_employerPhone"
              [ngClass]="
                sf.employerPhone &&
                sf.employerPhone.touched &&
                sf.employerPhone.errors
                  ? 'has-error'
                  : 'mobileView-pb-15'
              "
              class="form-group"
            >
              <p
                id="cac-income-label-s_employerPhone"
                htmlFor="employerPhone"
                class="dark-blue form-field-black"
                [class.validation-error]="
                  sf.employerPhone &&
                  sf.employerPhone.touched &&
                  sf.employerPhone.errors
                "
              >
                {{ formFieldData?.employerPhone?.label }}
              </p>
              <input
                id="cac-income-s_employerPhone"
                class="form-control col-right form-field-black"
                mask="000-000-0000"
                aria-labelledby="cac-income-label-s_employerPhone"
                name="s_employerPhone"
                formControlName="employerPhone"
                type="text"
                inputmode="numeric"
                (blur)="
                  parseInputAndValidate($event, 'employerPhone', 'secondary')
                "
              />
              <span
                *ngIf="
                  sf.employerPhone &&
                  sf.employerPhone.touched &&
                  sf.employerPhone.errors
                "
                class="validation-error-icon"
                ><img class="error-icn" src="{{ exclamation }}" alt="err"
              /></span>
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                sf.employerPhone &&
                sf.employerPhone.touched &&
                !sf.employerPhone.errors?.isNotEmpty &&
                (sf.employerPhone?.errors?.isOfType ||
                  sf.employerPhone?.errors?.isOfLength)
              "
              class="ErremployerPhone mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerPhone?.errors?.phe1 }}
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                sf.employerPhone &&
                sf.employerPhone.touched &&
                sf.employerPhone.errors?.isNotEmpty
              "
              class="ErremployerPhone mobileOnly required validation-error mobileView-pb-15 error-message"
            >
              {{ formFieldData?.employerPhone?.errors?.phe2 }}
            </div>
          </div>
        </div>
        <div class="form-group desktop">
          <div class="custom-display-inline col-md-8">
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                sf.employerName &&
                sf.employerName.touched &&
                sf.employerName.errors?.isNotEmpty
              "
              class="ErremployerName errWidthL required validation-error"
            >
              {{ formFieldData?.employerName?.errors?.ene2 }}
            </div>
          </div>
          <div class="custom-display-inline col-md-8">
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                sf.employerPhone &&
                sf.employerPhone.touched &&
                !sf.employerPhone.errors?.isNotEmpty &&
                (sf.employerPhone?.errors?.isOfType ||
                  sf.employerPhone?.errors?.isOfLength)
              "
              class="ErremployerPhone errWidthL required validation-error"
            >
              {{ formFieldData?.employerPhone?.errors?.phe1 }}
            </div>
            <div
              role="alert"
              aria-atomic="true"
              *ngIf="
                sf.employerPhone &&
                sf.employerPhone.touched &&
                sf.employerPhone.errors?.isNotEmpty
              "
              class="ErremployerPhone errWidthL required validation-error"
            >
              {{ formFieldData?.employerPhone?.errors?.phe2 }}
            </div>
          </div>
        </div>
      </div>
    </span>
    <button
      id="sinvisible"
      class="position-absolute invisible"
      disabled
    ></button>
  </form>
</div>
